import React from "react";
import Footer from "./Footer";
import { WifiOff } from "lucide-react";

const ConnectionError = ({ onRetry }) => {
  return (
    <div className="bg-white h-full flex flex-col justify-start p-4 min-h-screen">
      <div className="bg-gray-100 p-8 rounded-2xl mt-[calc(100vh/16)] mb-8">
        <div className="flex flex-col">
          <p className="text-2xl font-medium">Connection error</p>
          <p className="text-gray-500 text-md mt-4">
            We couldn't reach the server. Please check your connection and try again.
          </p>
        </div>
        <div className="flex flex-col items-center mt-8">
          <WifiOff height="72" width="72" color="#6b7280" />
        </div>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="w-full mt-8 bg-blue-600 text-white rounded-lg py-3 font-medium active:opacity-80"
          >
            Try again
          </button>
        )}
      </div>

      <div className="flex flex-1" />

      <Footer />
    </div>
  );
};

export default ConnectionError;
